import { ReactNode, useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';

interface Props { children: ReactNode }

export default function SupabaseAuthProvider({ children }: Props) {
  const { isLoaded, getToken, isSignedIn } = useAuth();

  useEffect(()=>{
    if(!isLoaded) return;
    
    const updateSupabaseAuth = async () => {
      try {
        if (!isSignedIn) {
          console.debug('User not signed in, clearing global token');
          // Store token globally for our custom functions to use
          (window as any).__clerkSupabaseToken = null;
          return;
        }

        // Get fresh token with force refresh
        const token = await getToken({ template: 'supabase', skipCache: true });
        console.debug('Got fresh Clerk JWT token for Supabase:', token ? 'Token received' : 'No token');

        if (token) {
          console.debug('Storing Clerk JWT token globally');
          // Store token globally for our custom functions to use
          (window as any).__clerkSupabaseToken = token;
          console.debug('Global token set:', (window as any).__clerkSupabaseToken ? 'Yes' : 'No');
        } else {
          console.debug('No token available, clearing global token');
          (window as any).__clerkSupabaseToken = null;
        }
      } catch(err){
        console.error('Failed to get Supabase token', err);
        (window as any).__clerkSupabaseToken = null;
      }
    };

    updateSupabaseAuth();

    // Set up interval to refresh token every 50 minutes (tokens expire after 1 hour)
    const interval = setInterval(updateSupabaseAuth, 50 * 60 * 1000);

    return () => clearInterval(interval);
  }, [isLoaded, getToken, isSignedIn]);

  return <>{children}</>;
} 